import React, { ReactElement } from 'react';
import { Tab, Tabs } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';

export interface ISnapshotTab {
  label: string;
}
const SnapshotTabsBase = (props: {
  children: ReactElement;
  onHandleChange: any;
  value: number;
  tabs: ISnapshotTab[];
  classes?: any;
}) => {
  const { value, onHandleChange, classes } = props;
  return (
    <TabContext value={String(value)}>
      <Tabs
        style={{ marginTop: '16px' }}
        value={value}
        onChange={onHandleChange}
        TabIndicatorProps={{ style: { background: 'transparent' } }}
        centered
        indicatorColor="primary"
        textColor="primary"
      >
        {props.tabs.map((tab, i) => (
          <Tab
            style={{
              borderBottom:
                value === i
                  ? 'solid 2px #0098c7'
                  : // : 'solid 1px rgb(194,192,195)',
                    'solid 1px #eef0f4',
            }}
            key={i}
            label={tab.label}
          />
        ))}
      </Tabs>
      {props.tabs.map((el, i) => (
        <TabPanel
          className={classes?.root}
          style={{ marginTop: '0px' }}
          key={i}
          value={String(i)}
        >
          {props?.children}
        </TabPanel>
      ))}
    </TabContext>
  );
};

export default SnapshotTabsBase;
